const swatchConstants = {
  SWATCH_SELECTED: "SWATCH_SELECTED",
  SWATCH_RESET: "SWATCH_RESET",
}

export default swatchConstants
